import React from 'react';

import { AttachMoney as AttachMoneyIcon, Percent as PercentIcon } from '@mui/icons-material';

import { Tuple } from '@clearverify/types';

import { RevenueShareType } from 'src/api';

export const REVENUE_SHARE_OPTIONS: Tuple<
  {
    component: React.ReactElement;
    value: RevenueShareType;
  },
  2
> = [
  {
    component: <AttachMoneyIcon />,
    value: RevenueShareType.Flat,
  },
  {
    component: <PercentIcon />,
    value: RevenueShareType.Percents,
  },
];
